import {
  ADMIN_TAG_LIST_REQUEST,
  ADMIN_TAG_LIST_SUCCESS,
  ADMIN_TAG_LIST_FAIL,
  ADMIN_TAG_CREATE_REQUEST,
  ADMIN_TAG_CREATE_SUCCESS,
  ADMIN_TAG_CREATE_FAIL,
  ADMIN_TAG_READ_REQUEST,
  ADMIN_TAG_READ_SUCCESS,
  ADMIN_TAG_READ_FAIL,
  ADMIN_TAG_UPDATE_REQUEST,
  ADMIN_TAG_UPDATE_SUCCESS,
  ADMIN_TAG_UPDATE_FAIL,
  ADMIN_TAG_UPDATE_RESET,
  ADMIN_INSTANT_OFF_UPDATE_REQUEST,
  ADMIN_INSTANT_OFF_UPDATE_SUCCESS,
  ADMIN_INSTANT_OFF_UPDATE_FAIL,
  ADMIN_ADD_PRODUCT_TAG_REQUEST,
  ADMIN_ADD_PRODUCT_TAG_SUCCESS,
  ADMIN_ADD_PRODUCT_TAG_FAIL,
  ADMIN_ADD_PRODUCTS_TAG_REQUEST,
  ADMIN_ADD_PRODUCTS_TAG_SUCCESS,
  ADMIN_ADD_PRODUCTS_TAG_FAIL,
  ADMIN_REMOVE_PRODUCT_TAG_REQUEST,
  ADMIN_REMOVE_PRODUCT_TAG_SUCCESS,
  ADMIN_REMOVE_PRODUCT_TAG_FAIL,
  ADMIN_REMOVE_PRODUCTS_TAG_REQUEST,
  ADMIN_REMOVE_PRODUCTS_TAG_SUCCESS,
  ADMIN_REMOVE_PRODUCTS_TAG_FAIL,
} from "./tagTypes";

export const tagReducer = (state = {}, action) => {
  switch (action.type) {
    // LIST
    case ADMIN_TAG_LIST_REQUEST:
      return { ...state, loading: true };
    case ADMIN_TAG_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        tags: action.payload,
      };
    case ADMIN_TAG_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    // READ
    case ADMIN_TAG_READ_REQUEST:
      return { ...state, loading: true };
    case ADMIN_TAG_READ_SUCCESS:
      return {
        ...state,
        loading: false,
        singleTag: action.payload,
      };
    case ADMIN_TAG_READ_FAIL:
      return { ...state, loading: false, error: action.payload };

    // CREATE
    case ADMIN_TAG_CREATE_REQUEST:
      return { ...state, loading: true };
    case ADMIN_TAG_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case ADMIN_TAG_CREATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // UPDATE
    case ADMIN_TAG_UPDATE_REQUEST:
      return { ...state, loading: true };
    case ADMIN_TAG_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.msg,
        success: action.payload,
      };
    case ADMIN_TAG_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // INSTANT OFF
    case ADMIN_INSTANT_OFF_UPDATE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_INSTANT_OFF_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.msg,
        success: true,
      };
    case ADMIN_INSTANT_OFF_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    case ADMIN_TAG_UPDATE_RESET:
      return {
        ...state,
        loading: false,
        message: "",
        success: null,
      };

    // MultiAdd
    case ADMIN_ADD_PRODUCTS_TAG_REQUEST:
      return { ...state, loading: false };

    case ADMIN_ADD_PRODUCTS_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        singleTag: action.payload,
      };
    case ADMIN_ADD_PRODUCTS_TAG_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Multiremove
    case ADMIN_REMOVE_PRODUCTS_TAG_REQUEST:
      return { ...state, loading: false };

    case ADMIN_REMOVE_PRODUCTS_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        singleTag: action.payload,
      };
    case ADMIN_REMOVE_PRODUCTS_TAG_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
